<div class="bg-light dark:bg-transparent min-vh-100 d-flex flex-row align-items-center">
  <c-container breakpoint="md">
    <c-row class="justify-content-center">
      <c-col lg="6" xl="5">
        <c-card-group>
          <c-card class="p-4 shadow-sm border-0">
            <c-card-body class="text-center">
              <!-- Logo / Branding -->
              <app-logo class="mb-4 d-block mx-auto" style="max-width: 180px;"></app-logo>

              <!-- Loading State -->
              @if (loading()) {
                <div class="my-5">
                  <h2 class="mb-4">{{ 'confirm_email.confirming_title' | translate }}</h2>
                  <c-spinner color="primary" variant="grow" class="mb-4"></c-spinner>
                  <p class="text-body-secondary">
                    {{ 'confirm_email.confirming_message' | translate }}
                  </p>
                </div>
              }

              <!-- Success State -->
              @if (success()) {
                <div class="my-5">
                  <div class="display-4 text-success mb-4">
                    <svg cIcon name="cilCheckCircle"></svg>
                  </div>
                  <h2 class="text-success mb-3">{{ 'confirm_email.success_title' | translate }}</h2>
                  <p class="lead mb-4">
                    {{ 'confirm_email.success_message' | translate }}
                  </p>
                  <p class="text-body-secondary mb-4">
                    {{ 'confirm_email.redirecting' | translate }}...
                  </p>
                  <button
                    cButton
                    color="primary"
                    size="lg"
                    routerLink="/login"
                    class="px-5"
                  >
                    {{ 'confirm_email.go_to_login' | translate }}
                  </button>
                </div>
              }

              <!-- Error State -->
              @if (error(); as errMsg) {
                <div class="my-5">
                  <div class="display-4 text-danger mb-4">
                    <svg cIcon name="cilXCircle"></svg>
                  </div>
                  <h2 class="text-danger mb-3">{{ 'confirm_email.error_title' | translate }}</h2>
                  <div class="alert alert-danger mb-4">
                    {{ errMsg }}
                  </div>
                  <p class="text-body-secondary mb-4">
                    {{ 'confirm_email.error_support' | translate }}
                  </p>
                  <button
                    cButton
                    color="primary"
                    size="lg"
                    routerLink="/login"
                    class="px-5"
                  >
                    {{ 'confirm_email.go_to_login' | translate }}
                  </button>
                </div>
              }
            </c-card-body>
          </c-card>
        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
</div>